<template>
<div >

    <v-content>
     

      <section id="about-me">

        <div class="pb-12"></div>
        

          <v-row class="px-9">
          <v-col cols="12" md="6" class="mr-3" >
                      
           <div class="text-center">
            <v-img
            :src="require('@/assets/lapiz.jpg')"
            height="800"
            >     
            </v-img>     
            </div>
            </v-col>
            <v-col  class="ml-3" >
          <h2 class=" text-center display-2 font-weight-bold mb-3">Archival Descriptions</h2>
          <v-responsive
            class="mx-auto mb-7"
            width="56"
          >


            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-responsive
            class="mx-auto black--text title font-weight-light mb-2 text-justify"
            max-width="1000"
          >
           <p class="mb-0">At the moment, the vast majority of Portuguese archives with an online presence use a software solution to manage their finding aids: e. g. Digitarq  or Archeevo.</p>

<p class="mb-0">Most of these finding aids are written in natural language without any annotation that would enable a machine to identify named entities, geographical locations or even some dates. 
That would allow the machine to create smart browsing tools on top of those record contents like entity linking and record linking. </p>

<p class="mb-0">In this work we have created a set of datasets to train Machine Learning algorithms to find those named entities and geographical locations. After training several algorithms we tested them in several datasets and registered their precision and accuracy.</p>

<p>These results enabled us to achieve some conclusions about what kind of precision we can achieve with this approach in this context and what to do with the results: do we have enough precision and accuracy to create toponymic and anthroponomic indexes for archival finding aids? Is this approach suitable in this context?
These are some of the questions we intend to answer along this work.</p>



         
          </v-responsive>
        <div class="text-center mb-10">

          <v-btn
            color="grey"
            href=""
            outlined
            large
          >
            <span class=" grey--text text--darken-1 font-weight-bold">
              Master Thesis
            </span>
          </v-btn>

          </div>
                    <v-row >
            <v-col class=" body-2 mx-auto font-weight-light text-justify">
              <p>Cunha, L. F., &amp; Ramalho, J. C. (2022). NER in Archival Finding Aids: Extended<em>. Machine Learning and Knowledge Extraction, <em>4</em>(1), 42–65.</em> <a href="https://www.mdpi.com/2504-4990/4/1/3" target="_blank">URL</a></p>
            <p>Cunha, L. F., &amp; Ramalho, J. C. (2021). NER in Archival Finding Aids. In <em>10th Symposium on Languages, Applications and Technologies (SLATE 2021)</em> (pp. 8:1–8:16). Schloss Dagstuhl – Leibniz-Zentrum für Informatik. <a href="https://drops.dagstuhl.de/opus/volltexte/2021/14425/" target="_blank">URL</a> </p>
         
<p>Cunha, L. F., &amp; Ramalho, J. C. (2021). Towards Entity Linking, NER in Archival
Finding Aids. In <em>Proceedings of Linked Archives International Workshop 2021
co-located with 25th International Conference on Theory and Practice of Digital Libraries (TPDL 2021)</em> (pp. 22–29). <a href="http://ceur-ws.org/Vol-3019/LinkedArchives_2021_paper_12.pdf" target="_blank">URL</a></p>


            </v-col>
          </v-row>
          </v-col>
          </v-row>

        
        <div class="py-12"></div>
        
        
      </section>

<section>
        <v-row
        no-gutters
        class="mx-5 px-12  justify-center"
        >
      <Entities/>
        </v-row>
</section>
    
   <section
    id="services"
    class="overflow-hidden white"
    
  >

    <v-row
      no-gutters
      class="mx-5 px-12"
    >


      <v-col
        class="text-center pa-5"
      >

       <v-col class="pb-9">
            <h2 class=" text-center display-2 font-weight-bold mb-3">Development</h2>
                      <v-responsive
            class="mx-auto mb-12"
            width="56"
          >
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>
           <v-responsive
            class="mx-auto title font-weight-light mb-5"
            max-width="1000"
          >
            <p >
              In order to develop a NER mechanism capable of extracting <br>
              Named Entities from archival documents the following aproaches were taken.
            </p>
             </v-responsive>
          </v-col>

        <v-row
          justify="center"
        >
         
          
          <v-col
            v-for="(service, i) in services"
            :key="i"
            class="text-center mb-3"
          >
            

    
    
            <img
            :width="width"
            height="100"
              :src="service.icon"
            >
              


            <h3 class="pa-3 font-weight-bold">
              <div
                class=""
                v-text="service.name"
              />
              </h3>
              <div class="font-weight-light" v-html="service.blurb" />
 
          </v-col>
         
        </v-row>
      </v-col>
    </v-row>
    <div class="py-12"></div>



  <section
    id="services"
    class="overflow-hidden white "
    
  >

    <v-row
      no-gutters
    >


      <v-col
        class="text-center pa-5 mt-12"
      >



        <v-row
          justify="center"
          class="mx-3"
          align="center"
        >
      <v-col cols="6"  class="pr-6">

               <v-col class="pb-9">
            <h2 class=" text-center display-2 font-weight-bold mb-3">Achieved Results</h2>
                      <v-responsive
            class="mx-auto "
            width="56"
          >

          </v-responsive>

          </v-col>
  <v-data-table
    :headers="headers"
    :items="results"
    :hide-default-footer="true"
    class="elevation-1"
  ></v-data-table>
            <v-divider class="mb-1 mt-12"></v-divider>

            <v-divider></v-divider>
             <v-responsive
            class="mx-auto title font-weight-light "
            max-width="1000"
          >
            <p >
              By trainning our own models we were able to achieve <br>
              very satisfactory results with this NER technique.
            </p>
             </v-responsive>
      </v-col>
      <v-col cols="6" class="pl-3">
        <v-img
            :src="require('@/assets/archive3.jpg')"
            >     
            </v-img>    
      </v-col>

         
        </v-row>
      </v-col>
    </v-row>
    <div class="py-12"></div>
              
  </section>


  </section>
      <section
        id="features"
        :style="{'background-image': 'url('+ require('@/assets/wall8.jpg')+')','background-repeat': 'repeat-y'}"
        class="grey lighten-3"
      >
        <div class="py-12"></div>

        <div class="text-center px-9">
          <h2 class="display-2 font-weight-bold mb-3">Frameworks</h2>

          <v-responsive
            class="mx-auto mb-12"
            width="56"
          >
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>
          <v-row >
            <v-col
              v-for="({ icon, title, text,link,width,button }, i) in features"
              :key="i"
              cols="12"
              md="4"
            >
              <v-card
                class="py-12 px-4"
                color="grey lighten-5"
                elevation="3"
                flat
              >
                <v-theme-provider >
                  <div>

                     <img
                     :width="width"
                     height="70"
                        :src="icon"
                      >

                  </div>
                </v-theme-provider>

                <v-card-title
                  class="justify-center font-weight-black text-uppercase"
                  v-text="title"
                ></v-card-title>

                <v-card-text
                  class="subtitle-1  text-justify"
                  
                >
                {{text}}
           <div class="text-center pt-9">

          <v-btn
            color="grey"
            @click="$router.push(link)"
            outlined
            large
          >
            <span class="grey--text text--darken-1 font-weight-bold">
              {{button}}
            </span>
          </v-btn>
          </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </div>

        <div class="py-12"></div>
      </section>

     
    </v-content>


  </div>
</template>
  <script>
import HelloWorld from '@/components/HelloWorld.vue'
import Entities from '@/components/Entities.vue'

export default {
  name: 'Home',
    components: {
      Entities
    },
   data () {
      return {
        features: [
          {
            icon: require("@/assets/opennlp.png"),
            title: 'OpenNLP',
            button:"NER with OpenNLP",
            width: 200,
            text: 'Apache OpenNLP is a machine learning-based toolkit implemented in Java, developed by Apache. Essentially and as its name implies, its purpose is the processing of natural language through the use of ML algorithms having a wide range of features, such as tokenization, named entity extraction, etc.',
            link:"OpenNLP"
          },
          {
            icon: require("@/assets/spacy.png"),
            title: 'spaCy',
            button:"NER with spaCy",
            width: 200,
            text: 'spaCy is an open-source library for advanced natural language processing, developed by Explosion company. This library offers several features associated with NLP which provides several base models of different languages such as Chinese, Danish, Dutch, English, French, Portuguese, etc',
            link:"spaCy"
          },
          {
            icon: require("@/assets/tensorflow3.png"),
            title: 'TensorFlow',
            button:"NER with TensorFlow",
            width: 300,
            text: 'The Tensorflow library, developed by Google, presents a vast set of ML features, usually associated with neural networks, which allow to develop and train models in a similar way to the learning method of the human mind. It is an Open Source library, published under Apache 2.0 license.',
            link:"TensorFlow"
          },
        ],
         services: [
        {
          name: 'Aata Annotation and Processing',
          icon: require("@/assets/parse.jpg"),
          width: 300,
          blurb: 'The first step consists of annotating the data and then, generate numerical representations from the word tokens.',
        },
        {
          name: 'ML Trainning',
          icon: require("@/assets/train.png"),
          width: 300,
          blurb: 'With annotated data we can teach a Machine Learning model to predict the named entity of a given token.',
        },
        {
          name: 'Entity Recognition',
          icon: require("@/assets/image3.png"),
          width: 500,
          blurb: 'With the ML model trainned, we use it to extract named entities from Archival Finding Aids.',
        },
        {
          name: 'Validation',
          icon: require("@/assets/validation.png"),
          width: 300,
          blurb: 'Finally, after the entity extraction, a validation process is applied in order to measure the performance of the ML models',
        },
      ],
      headers: [
          {
            text: 'Corpus',
            align: 'start',
            sortable: false,
            value: 'corpus',
          },
          { text: 'OpenNLP', value: 'opennlp' },
          { text: 'spaCy', value: 'spaCy' },
          { text: 'TensorFlow', value: 'tensorflow' },
        ],
        results: [
          {
            corpus: 'IFIP ',
            opennlp: "F1-score: 86.41%",
            spaCy: "F1-score: 87.84%",
            tensorflow: "F1-score: 94.08%",
          },
          {
            corpus: 'Família Araújo Azevedo ',
            opennlp: "F1-score: 71.66%",
            spaCy: "F1-score: 75.98%",
            tensorflow: "F1-score: 78.89%",
          },
          {
            corpus: 'Arquivo da Casa Avelar',
            opennlp: "F1-score: 85.11%",
            spaCy: "F1-score: 87.18%",
            tensorflow: "F1-score: 87.99%",
          },
          {
            corpus: 'Inquirições de Genere 1',
            opennlp: "F1-score: 99.57%",
            spaCy: "F1-score: 97.52%",
            tensorflow: "F1-score: 100%",
          },
          {
            corpus: 'Inquirições de Genere 2',
            opennlp: "F1-score: 69.80%",
            spaCy: "F1-score: 87.26%",
            tensorflow: "F1-score: 94,82%",
          },
          {
            corpus: 'Jardim do Mar',
            opennlp: "F1-score: 99.71%",
            spaCy: "F1-score: 99.57%",
            tensorflow: "F1-score: 99.72%",
          },
          {
            corpus: 'Curral das Freiras	',
            opennlp: "F1-score: 100%",
            spaCy: "F1-score: 100%",
            tensorflow: "F1-score: 100%",
          },
        ],
      }
    },
   
}
</script>
